(function ($, App, Utils, Components) {
  'use strict';

  const logger = new Logger("PreferredStore");

  Components.create('PreferredStore', {

    Selectors: {
      main: '[data-preferredstore]',
      excluded: '[data-preferredstore-excluded]'
    },

    Events: {
      storeSaved: 'storecookie:saved',
    },

    refresh: () => {

    },

    bindEvents: function () {

      App.Body.on('click.ps', Components.PreferredStore.Selectors.main, function (e) {
        // e.stopPropagation();

        let $this = $(this);
        let data = Utils.jsonDA($this, 'preferredstore');

        if (!data.active) {
          return;
        }

        if (data.delete) {
          Cookies.remove('storeId');
        } else {
          Cookies.set('storeId', data.id);
          Components.trigger(Components.PreferredStore.Events.storeSaved, {storeId: data.id});
        }

        if (data.reload) {
          return location.reload();
        } else if (data.navigate) {
          if(!e || "_blank" !== e.target.getAttribute("target")) {
              return window.location.href = data.navigate;
          }
        }

      });


    },


    init: function () {
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
